<template>
    <Dropdown class="modules-dropdown" @on-click="handleClick" v-if="modules && modules.length > 1">
      <span style="cursor:pointer;">{{module.name}}</span>
      <Icon :size="18"  tyle="cursor:pointer;" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem :selected="active === module.id" :name="module.id" v-for="module in modules" :key="module.id">{{module.name}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters(['modules']),
    module () {
      let index = this.modules.findIndex(item => item.id === this.active)
      return index !== -1 ? this.modules[index] : this.modules[0]
    }
  },
  watch: {
    active (val) {
      this.$store.dispatch('setRoutes', this.module.routes)
    },
    '$route': {
      immediate: true,
      deep: true,
      handler (route) {
        if (route) {
          let index = this.modules.findIndex(item => item.id === route.meta.moduleId)
          if (index === -1) {
            this.active = this.modules[0].id
            index = 0
          } else this.active = this.modules[index].id
          this.$store.dispatch('setRoutes', this.modules[index].routes)
        }
      }
    }
  },
  data () {
    return {
      active: 1
    }
  },
  methods: {
    handleClick (state) {
      this.active = state
      this.$nextTick(() => {
        this.$router.replace({name: this.module.home})
      })
    }
  }
}
</script>

<style lang="less">
@import './modules.less';
</style>



// WEBPACK FOOTER //
// src/components/main/components/header-bar/modules/modules.vue